import { Controller } from "@hotwired/stimulus"

// INTENT: Let someone close a notice for good in this browser (e.g. the classroom "practice test reports have moved"
// notice), without a server round trip or database write.
// EXPECTED OUTCOME: The notice renders hidden; connect() shows it unless this browser dismissed it before, and close()
// hides it and remembers that under data-dismissible-key-value.
// CAVEAT/TRAP: localStorage can throw (private windows, blocked storage); then the notice just shows and closes for
// this page view only.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.dismissed()) {
      this.element.remove()
    } else {
      this.element.hidden = false
    }
  }

  close() {
    try {
      localStorage.setItem(this.storageKey, "1")
    } catch {
      // Storage unavailable: still hide it for this page view.
    }
    this.element.remove()
  }

  dismissed() {
    try {
      return localStorage.getItem(this.storageKey) === "1"
    } catch {
      return false
    }
  }

  get storageKey() {
    return `dismissed:${this.keyValue}`
  }
}
